import { ServicesResponse } from 'src/js/model/api/response/services-response';
import { Services } from 'src/js/model/services';

export const mapServices = (response: ServicesResponse): Services => ({
  ems: !!response.ems,
  http: !!response.http,
  nmos: !!response.nmos,
  onvif: !!response.onvif,
  passthrough: !!response.passthrough,
  passthroughPort: response.passthroughPort,
  preview: !!response.preview,
  rtsp: !!response.rtsp,
  snmp: !!response.snmp,
  ssh: !!response.ssh,
  telnet: !!response.telnet,
  // nic object
  nic: response.nic,
});
